import React from 'react';
import styled from 'styled-components';

const OuterDiv = styled.div`
    padding: 25px;
`

const CardDiv = styled.div`
    width: 250px;
    height: 275px;
    margin: auto;
    background-image: url(https://images.unsplash.com/photo-1602475063211-3d98d60e3b1f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8c3BlY2tsZWR8ZW58MHx8MHx8&w=1000&q=80);
    padding-top: 10px;
`
const Image = styled.div`
    margin: auto;
    width: 175px;
    height: 175px;
    background-image: url(${(props) => props.image});
    background-size: cover;
`
const CaptionDiv = styled.div`
    padding-top: 10px;
    text-align: center;
    color: white;
    font-family: 'Josefin Sans', sans-serif;
`

function ArticleCardMobile(props) {
    let image = props.image
    let articleLink = props.articleLink
    let articleTitle = props.articleTitle
    let author = props.author
    return (
        <OuterDiv>
            <CardDiv>
                <Image image = {image}/>
                <CaptionDiv>
                    <a href={articleLink} style = {{color: 'white'}}>{articleTitle}</a>
                    <p>By: {author}</p>
                </CaptionDiv>
            </CardDiv>
        </OuterDiv>
    );
}

export default ArticleCardMobile